export default () => ({
  sendPromotionView(promotion) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_promotion',
      ecommerce: {
        creative_name: promotion.creative,
        creative_slot: promotion.slot,
        promotion_id: promotion.id,
        promotion_name: promotion.name,
        items: [],
      },
    });
  },
});
